(function () {
  'use strict';

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function highlight(label, query) {
    var safeLabel = escapeHtml(label);
    if (!query) return safeLabel;
    var idx = label.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return safeLabel;
    var before = escapeHtml(label.slice(0, idx));
    var match = escapeHtml(label.slice(idx, idx + query.length));
    var after = escapeHtml(label.slice(idx + query.length));
    return before + '<mark>' + match + '</mark>' + after;
  }

  function initTownSearch(root) {
    var dataScript = root.querySelector('[data-town-search-data]');
    var input = root.querySelector('[data-town-search-input]');
    var resultsEl = root.querySelector('[data-town-search-results]');
    var emptyEl = root.querySelector('[data-town-search-empty]');
    var clearBtn = root.querySelector('[data-town-search-clear]');
    if (!dataScript || !input || !resultsEl) return;

    var items = [];
    try {
      items = JSON.parse(dataScript.textContent || '[]');
    } catch (e) {
      items = [];
    }
    items = items.filter(function (item) {
      return item && item.url && (item.label || item.town);
    });

    var maxResults = parseInt(root.getAttribute('data-max-results'), 10) || 8;
    var minChars = parseInt(root.getAttribute('data-min-chars'), 10) || 1;
    var activeIndex = -1;
    var currentMatches = [];

    function closeResults() {
      resultsEl.setAttribute('hidden', '');
      resultsEl.innerHTML = '';
      emptyEl && emptyEl.setAttribute('hidden', '');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      currentMatches = [];
    }

    function renderMatches(query, matches) {
      resultsEl.innerHTML = '';
      matches.forEach(function (item, i) {
        var li = document.createElement('li');
        li.className = 'town-search__result';
        li.setAttribute('role', 'option');
        li.id = root.id + '-option-' + i;

        var a = document.createElement('a');
        a.className = 'town-search__result-link';
        a.href = item.url;
        a.setAttribute('tabindex', '-1');

        var imgWrap = document.createElement('span');
        imgWrap.className = 'town-search__result-image';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 44;
          img.height = 44;
          imgWrap.appendChild(img);
        }

        var textWrap = document.createElement('span');
        textWrap.className = 'town-search__result-text';

        var labelEl = document.createElement('span');
        labelEl.className = 'town-search__result-label';
        labelEl.innerHTML = highlight(item.label || item.town, query);

        var ctaEl = document.createElement('span');
        ctaEl.className = 'town-search__result-cta';
        ctaEl.textContent = 'Shop this town →';

        textWrap.appendChild(labelEl);
        textWrap.appendChild(ctaEl);
        a.appendChild(imgWrap);
        a.appendChild(textWrap);
        li.appendChild(a);
        resultsEl.appendChild(li);
      });
      resultsEl.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
    }

    function search(rawQuery) {
      var query = rawQuery.trim().toLowerCase();

      if (clearBtn) {
        if (rawQuery) {
          clearBtn.removeAttribute('hidden');
        } else {
          clearBtn.setAttribute('hidden', '');
        }
      }

      if (query.length < minChars) {
        closeResults();
        return;
      }

      var starts = [];
      var contains = [];
      items.forEach(function (item) {
        var townLower = (item.town || item.label || '').toLowerCase();
        if (townLower.indexOf(query) === 0) {
          starts.push(item);
        } else if (item.search && item.search.indexOf(query) !== -1) {
          contains.push(item);
        }
      });

      var matches = starts.concat(contains).slice(0, maxResults);
      currentMatches = matches;
      activeIndex = -1;

      if (matches.length === 0) {
        resultsEl.setAttribute('hidden', '');
        resultsEl.innerHTML = '';
        emptyEl && emptyEl.removeAttribute('hidden');
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      emptyEl && emptyEl.setAttribute('hidden', '');
      renderMatches(query, matches);
    }

    var debouncedSearch = debounce(search, 90);

    input.addEventListener('input', function (e) {
      debouncedSearch(e.target.value);
    });

    input.addEventListener('focus', function (e) {
      if (e.target.value.trim().length >= minChars) {
        search(e.target.value);
      }
    });

    input.addEventListener('keydown', function (e) {
      var options = resultsEl.querySelectorAll('.town-search__result');
      if (!options.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, options.length - 1);
        updateActive(options);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        updateActive(options);
      } else if (e.key === 'Enter') {
        if (activeIndex > -1 && currentMatches[activeIndex]) {
          e.preventDefault();
          window.location.href = currentMatches[activeIndex].url;
        }
      } else if (e.key === 'Escape') {
        closeResults();
        input.blur();
      }
    });

    function updateActive(options) {
      options.forEach(function (opt, i) {
        if (i === activeIndex) {
          opt.classList.add('is-active');
          input.setAttribute('aria-activedescendant', opt.id);
          opt.scrollIntoView({ block: 'nearest' });
        } else {
          opt.classList.remove('is-active');
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        closeResults();
        clearBtn.setAttribute('hidden', '');
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        closeResults();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-town-search]').forEach(initTownSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-town-search]');
    if (root) initTownSearch(root);
  });
})();
